import APIService from "./APIService";

export default {
  getIncidenciaSuspensoesIndevidasVisaoMensal(
    regional = 0,
    competenciaDe,
    competenciaAte
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-religacao/get-incidencia-suspensoes-indevidas-visao-mensal?regional=${regional}&competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },

  getQntdTotalSuspensoesIndevidasVisaoMensal(
    regional = 0,
    competenciaDe,
    competenciaAte
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-religacao/get-qtnd-total-suspensoes-indevidas-visao-mensal?regional=${regional}&competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },

  getPercentualServicosReligacaoVisaoMensal(
    regional = 0,
    competenciaDe,
    competenciaAte,
    servicos
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-religacao/get-percentual-servicos-religacao-concluidos-fora-prazo-visao-mensal?regional=${regional}&competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&servicos=${servicos}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },

  getQntdServicosDescumpridosVisaoMensal(
    regional = 0,
    competenciaDe,
    competenciaAte,
    servicos
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-religacao/get-qntd-servicos-descuprimento-prazo-visao-mensal?regional=${regional}&competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&servicos=${servicos}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },
  getIncidenciaSuspensoesIndevidasVisaoMensalAcumulados(
    regional = 0,
    competenciaDe,
    competenciaAte
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-religacao/get-incidencia-suspensoes-indevidas-visao-mensal-acumuladas?regional=${regional}&competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },

  getQtndTotalSuspensoesIndevidasVisaoMensalAcumulados(
    regional = 0,
    competenciaDe,
    competenciaAte
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-religacao/get-qtnd-total-suspensoes-indevidas-visao-mensal-acumuladas?regional=${regional}&competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },

  getPercentualServicosReligacaoVisaoMensalAcumulados(
    regional = 0,
    competenciaDe,
    competenciaAte,
    servicos
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-religacao/get-percentual-servicos-religacao-concluidos-fora-prazo-visao-mensal-acumuladas?regional=${regional}&competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&servicos=${servicos}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },

  getQntdServicosDescumpridosVisaoMensalAcumulados(
    regional = 0,
    competenciaDe,
    competenciaAte,
    servicos
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-religacao/get-qntd-servicos-descuprimento-prazo-visao-mensal-acumuladas?regional=${regional}&competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&servicos=${servicos}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },

  getQntdServicosRealizadosVisaoMensal(
    regional = 0,
    competenciaDe,
    competenciaAte,
    servicos
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-religacao/get-qntd-servicos-realizados-visao-mensal?regional=${regional}&competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&servicos=${servicos}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },

  getQntdServicosRealizadosVisaoMensalAcumuladas(
    regional = 0,
    competenciaDe,
    competenciaAte,
    servicos
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-religacao/get-qntd-servicos-realizados-visao-mensal-acumuladas?regional=${regional}&competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&servicos=${servicos}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },

  getIncidenciaSuspensoesIndevidasPorMunicipio(
    regional = 0,
    competenciaDe,
    competenciaAte,
    servicos
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-religacao/get-incidencia-suspensoes-indevidas-por-municipio?regional=${regional}&competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&servicos=${servicos}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },

  getQtndTotalSuspensoesIndevidasPorMunicipio(
    regional = 0,
    competenciaDe,
    competenciaAte,
    servicos
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-religacao/get-qtnd-total-suspensoes-indevidas-por-municipio?regional=${regional}&competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&servicos=${servicos}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },

  getPercentualServicosReligacaoConcluidosForaPrazoPorMunicipio(
    regional = 0,
    competenciaDe,
    competenciaAte,
    servicos
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-religacao/get-percentual-servicos-religacao-concluidos-fora-prazo-por-municipio?regional=${regional}&competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&servicos=${servicos}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },

  getQntdServicosDescumpridosPorMunicipio(
    regional = 0,
    competenciaDe,
    competenciaAte,
    servicos
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-religacao/get-qntd-servicos-descuprimento-prazo-por-municipio?regional=${regional}&competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&servicos=${servicos}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },
  getQntdServicosRealizadosPorMunicipio(
    regional = 0,
    competenciaDe,
    competenciaAte,
    servicos
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-religacao/get-qntd-servicos-realizados-por-municipio?regional=${regional}&competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&servicos=${servicos}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },

  getKpisAgregadosPorMunicipio(
    regional = 0,
    competenciaDe,
    competenciaAte,
    servicos
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-religacao/get-kpis-agregados-por-municipio?regional=${regional}&competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&servicos=${servicos}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },
};
